import "./AreasWeCover.module.css";
import Header from "@/reusable_sections/Header";
import HeroIntroduction from "./sections/HeroIntroduction";
import ServiceAreasList from "./sections/ServiceAreasList";
import Footer from "@/reusable_sections/Footer";
export default function AreasWeCoverPage() {
  return <div>
      <Header />
      <HeroIntroduction />
      <ServiceAreasList />
      <Footer />
    </div>;
}